import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AutenticarService } from './autenticar.service';

@Component({
    selector: 'app-autenticar',
    templateUrl: './autenticar.component.html',
    styleUrls: ['./autenticar.component.scss'],
})
export class AutenticarComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        private autenticarService: AutenticarService,
        private router: Router
    ) {}

    color = 'warn';
    mode = 'indeterminate';
    value = 50;
    diameter = 40;

    ngOnInit(): void {
        this.activatedRoute.queryParams
            .pipe(filter((params) => params.token))
            .subscribe((params) => {
                this.autenticarService.login(params.token).subscribe(
                    () => {
                        const lang = window.location.pathname.split('/')[1];

                        this.router.navigate([`/${lang}/alunos`]);
                    },
                    (err) => console.warn(err)
                );
            });
    }
}
